var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.8,
    height: 21.2,
    viewBox: "0 0 21.8 21.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19,2.49H16.83V.9A.9.9,0,1,0,15,.9V2.49H6.77V.9A.9.9,0,0,0,5,.9V2.49H2.76A2.79,2.79,0,0,0,0,5.29V18.4a2.79,2.79,0,0,0,2.76,2.8H19a2.79,2.79,0,0,0,2.76-2.8V5.29A2.79,2.79,0,0,0,19,2.49ZM2.76,4.29H5V5a.9.9,0,0,0,1.8,0V4.29H15V5a.9.9,0,1,0,1.8,0V4.29H19a1,1,0,0,1,1,1V7.62H1.8V5.29A1,1,0,0,1,2.76,4.29ZM19,19.4H2.76a1,1,0,0,1-1-1v-9H20v9A1,1,0,0,1,19,19.4Z",
    fill: "#624de3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.c4ab3490a790a9cec48425f9d7ccbe7a.svg";
export { ForwardRef as ReactComponent };